import makeStyles from "@mui/styles/makeStyles";

const useStyle = makeStyles((theme) => {
  return {
    mainContainer: {
      padding: "0px",
      backgroundColor: "#FFFFFF",
      position: "relative",
      minHeight: "100vh",
      backgroundImage: "none",
      backgroundSize: "auto",
      backgroundPosition: "right",
      backgroundRepeat: "no-repeat",
      // Header is 64px tall on desktop, plus an extra ~56px row for the
      // mobile-only search input below the toolbar.
      marginTop: "64px",
      [theme.breakpoints.down("md")]: {
        marginTop: "120px",
      },
    },
    bgImage: {
      position: "absolute",
      top: 0,
      right: 0,
      zIndex: -9,
    },
    divider: {
      width: "180px",
      backgroundColor: theme.palette.primary.main,
      height: 6,
      borderRadius: 3,
    },
  };
});

export default useStyle;
